export var SHOW_INFO_VALUES;
(function (SHOW_INFO_VALUES) {
    SHOW_INFO_VALUES[SHOW_INFO_VALUES["ON_MOUSE_OVER"] = 1] = "ON_MOUSE_OVER";
    SHOW_INFO_VALUES[SHOW_INFO_VALUES["ALWAYS"] = 2] = "ALWAYS";
    SHOW_INFO_VALUES[SHOW_INFO_VALUES["NEVER"] = 3] = "NEVER";
})(SHOW_INFO_VALUES || (SHOW_INFO_VALUES = {}));
export const CLASSIC_SHOW_INFO_VALUES = [
    SHOW_INFO_VALUES.ON_MOUSE_OVER,
    SHOW_INFO_VALUES.ALWAYS,
];
export const STRIP_SHOW_INFO_VALUES = [
    SHOW_INFO_VALUES.ON_MOUSE_OVER,
    SHOW_INFO_VALUES.ALWAYS,
    SHOW_INFO_VALUES.NEVER,
];
export const COMPACT_SHOW_INFO_VALUES = [
    SHOW_INFO_VALUES.ON_MOUSE_OVER,
    SHOW_INFO_VALUES.ALWAYS,
    SHOW_INFO_VALUES.NEVER,
];
//# sourceMappingURL=show-info-values.js.map